import { graphql } from '~/graphql';
import { useGraphqlMutation } from '~/hooks/useGraphqlMutation';

export const useUpsertBuyerInventoryConfiguration = () => {
  const upsertBuyerInventoryConfigurationMutation = graphql(`
    mutation upsertBuyerInventoryConfiguration(
      $platformProductsLengthId: ID!
      $locationId: ID!
      $usageRatePerWeek: QuantityInput!
      $weeksCoveredBeforeMonitor: Float
      $weeksCoveredBeforeUrgent: Float
      $targetWeeksCovered: Float
    ) {
      upsertBuyerInventoryConfiguration(
        platformProductsLengthId: $platformProductsLengthId
        locationId: $locationId
        usageRatePerWeek: $usageRatePerWeek
        weeksCoveredBeforeMonitor: $weeksCoveredBeforeMonitor
        weeksCoveredBeforeUrgent: $weeksCoveredBeforeUrgent
        targetWeeksCovered: $targetWeeksCovered
      ) {
        id
        usageRatePerWeek {
          value
          unit
        }
        weeksCoveredBeforeMonitor
        weeksCoveredBeforeUrgent
        targetWeeksCovered
        location {
          id
          name
        }
        platformProductsLength {
          id
          platformProduct {
            name
          }
        }
      }
    }
  `);
  return useGraphqlMutation(upsertBuyerInventoryConfigurationMutation, [
    'buyerInventories',
  ]);
};
